import { render, staticRenderFns } from "./UserIpLog.vue?vue&type=template&id=5e47e613&scoped=true&"
import script from "./UserIpLog.vue?vue&type=script&lang=js&"
export * from "./UserIpLog.vue?vue&type=script&lang=js&"
import style0 from "./UserIpLog.vue?vue&type=style&index=0&id=5e47e613&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e47e613",
  null
  
)

export default component.exports